import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Butterfly } from "@/components/site/Logo";

const links = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Clients", href: "#clients" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Book", href: "#payment" },
  { label: "Contact", href: "#inquiry" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <motion.header
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="fixed top-0 left-0 right-0 z-40"
        data-testid="site-navbar"
        style={{
          backdropFilter: scrolled ? "blur(18px)" : "blur(0px)",
          background: scrolled ? "rgba(245,240,225,0.85)" : "transparent",
          borderBottom: scrolled ? "1px solid rgba(10,10,20,0.08)" : "1px solid transparent",
          transition: "background 0.5s ease, border-color 0.5s ease, backdrop-filter 0.5s ease",
        }}
      >
        <div className="container-mit flex items-center justify-between h-20">
          <a href="#top" className="flex items-center gap-3 group" data-testid="brand-mark">
            <Butterfly size={44} className="transition-transform duration-500 group-hover:scale-110" />
            <div className="hidden sm:block">
              <div className="text-[#0A0A14] font-display text-lg leading-none">Metamorphosis</div>
              <div className="text-[10px] tracking-[0.28em] text-[#A4801C] mt-1">SINCE 2012</div>
            </div>
          </a>
          <nav className="hidden lg:flex items-center gap-10">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.label.toLowerCase()}`}
                className="text-[12px] tracking-[0.2em] uppercase text-[#0A0A14]/70 hover:text-[#4B1EAD] transition-colors"
              >
                {l.label}
              </a>
            ))}
          </nav>
          <a href="#inquiry" className="hidden md:inline-flex btn-editorial" data-testid="nav-cta">
            Start a project <span className="arrow">→</span>
          </a>
          <button className="lg:hidden text-[#0A0A14] p-2" onClick={() => setOpen(true)} data-testid="mobile-menu-open">
            <Menu size={22} />
          </button>
        </div>
      </motion.header>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 lg:hidden"
            style={{ background: "rgba(245,240,225,0.98)", backdropFilter: "blur(20px)" }}
            data-testid="mobile-menu"
          >
            <div className="container-mit h-20 flex items-center justify-between">
              <Butterfly size={40} />
              <button className="text-[#0A0A14] p-2" onClick={() => setOpen(false)} data-testid="mobile-menu-close"><X /></button>
            </div>
            <div className="container-mit mt-10 flex flex-col gap-6">
              {links.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ delay: i * 0.06 }}
                  className="font-display text-4xl text-[#0A0A14]"
                  data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                >
                  {l.label}
                </motion.a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

function BrandMark() {
  return null;
}
